import { Component, HostBinding, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DfControlValueDirective } from '../../forms';
import {
  DfIconSize,
  DfIconRegistry,
  DfIconMagnifyingGlass16,
} from '../../icon';

@Component({
  selector: 'df-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DfSearchBoxComponent,
      multi: true,
    },
  ],
})
export class DfSearchBoxComponent extends DfControlValueDirective<string> {
  @Input() public size: DfIconSize = 'medium';
  @Input() public placeholder = 'Search';
  @Input() public searchId = 'df-search';
  @Input()
  public icon = 'search';
  @HostBinding('class.df-search-box--disabled')
  public override disabled: boolean = false;
  constructor(private readonly iconFactory: DfIconRegistry) {
    super();
    this.iconFactory.registerIcons([DfIconMagnifyingGlass16]);
  }

  public changeEvent(data): void {
    this.handleOnChangeEvent(data);
  }
}
